<div class="max-h-[90vh] w-full px-4">
  <h2 class="text-xl font-semibold mt-1 pb-1 w-full">{{ '#WWS_CORE.COMMANDS.ARTIKELINFO.NAME' | translate }}</h2>

  <div class="overflow-y-auto max-h-[80vh] pb-2 overflow-x-hidden">
    <ng-container *ngComponentOutlet="modalComponent; inputs: inputs"></ng-container>
  </div>
</div>

